import React from 'react';
import jwt_decode from 'jwt-decode';
import { useSelector } from 'react-redux';
import moment from 'moment';

const AuthContext = React.createContext({
  app: false,
  portal: false,
  registry: false,
  require_change_pw: false
});

const isTokenInvalid = token =>
  !token || jwt_decode(token).exp < Date.now() / 1000;

const isPortalTokenInvalid = token => {
  if (!token) return true;

  const decodedJwt = jwt_decode(token);

  return (
    decodedJwt.exp < Date.now() / 1000 ||
    moment
      .unix(decodedJwt.exp)
      .subtract(12, 'hours')
      .date() !== moment().date()
  );
};
const isTokenInvalidManilaWallClock = token => {
  if (!token) {
    return true;
  }

  const now = new Date();

  // Extract literal numbers from device clock and assign Asia/Manila timezone
  const wallClockManilaTime = moment.tz(
    [
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      now.getHours(),
      now.getMinutes(),
      now.getSeconds(),
      now.getMilliseconds()
    ],
    'Asia/Manila'
  );

  const currentTimestampSec = wallClockManilaTime.unix();

  return jwt_decode(token).exp < currentTimestampSec;
};

const AuthProvider = ({ children }) => {
  const {
    userToken,
    loginToken,
    mustSelectBiz,
    isBizSelected,
    portal,
    require_change_pw
  } = useSelector(state => state.auth);

  const portalToken = portal?.token || null;

  const isValidLogin =
    !isTokenInvalid(userToken) && !isTokenInvalid(loginToken);

  const offsetMinutes = new Date().getTimezoneOffset();
  const offSetHours = (offsetMinutes / 60) * -1;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isManilaTzValid =
    !isValidLogin &&
    !isTokenInvalidManilaWallClock(userToken) &&
    !isTokenInvalidManilaWallClock(loginToken);
  const tokensReceived = Boolean(userToken && loginToken);
  const app =
    isValidLogin && (!mustSelectBiz || (mustSelectBiz && isBizSelected));
  const isPortal = !isPortalTokenInvalid(portalToken);
  const registry = isValidLogin && mustSelectBiz && !isBizSelected;

  return (
    <AuthContext.Provider
      value={{
        app,
        portal: isPortal,
        registry,
        require_change_pw,
        tokenData: { tokensReceived },
        timeZoneData: { isManilaTzValid, timezone, offSetHours }
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
export { AuthProvider };
